import { MapPin } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const stops = [
  { city: "Biella", coord: "45.5630° N · 8.0540° E", note: "Punto di partenza" },
  { city: "Sagliano Micca", coord: "45.5870° N · 8.0480° E", note: "Sede GMB Graniti" },
  { city: "Campiglia Cervo", coord: "45.6740° N · 8.0410° E", note: "Frazione Balma" },
  { city: "Cava della Balma", coord: "45.6850° N · 8.0350° E", note: "1100 m s.l.m." },
];

export default function Localizzazione() {
  return (
    <section
      id="localizzazione"
      data-testid="localizzazione-section"
      className="relative bg-[var(--surface-1)] border-y border-[var(--border-subtle)] section-pad section-gap"
    >
      <div className="grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-4">
          <p className="text-[0.7rem] tracking-[0.3em] uppercase text-neutral-500 mb-3">
            03 / Località
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-neutral-50 leading-[0.95]">
            Risalendo
            <br />
            <span className="italic font-editorial font-normal text-[var(--accent)]">
              la Valle Cervo.
            </span>
          </h2>
          <p className="mt-6 text-neutral-400 leading-relaxed max-w-sm">
            Dalla pianura biellese alla sede operativa di Sagliano Micca,
            risalendo fino alla storica cava della Balma a Campiglia Cervo.
          </p>
        </Reveal>

        <Reveal className="md:col-span-8" delay={0.15}>
          {/* Stylized map */}
          <div className="relative bg-[var(--bg)] border border-[var(--border-subtle)] aspect-[16/9] overflow-hidden">
            <svg viewBox="0 0 800 450" className="absolute inset-0 w-full h-full">
              <defs>
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1f1f1f" strokeWidth="0.5" />
                </pattern>
                <linearGradient id="route" x1="0" x2="1">
                  <stop offset="0%" stopColor="#a69c8a" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#a69c8a" stopOpacity="1" />
                </linearGradient>
              </defs>
              <rect width="800" height="450" fill="url(#grid)" />

              {/* Topographic curves */}
              {[0, 1, 2, 3, 4].map((i) => (
                <path
                  key={i}
                  d={`M 0 ${360 - i * 35} Q 200 ${320 - i * 30} 400 ${300 - i * 32} T 800 ${260 - i * 30}`}
                  fill="none"
                  stroke="#262626"
                  strokeWidth="1"
                />
              ))}

              {/* Route line */}
              <path
                d="M 80 360 C 220 320, 360 280, 480 220 S 680 130, 720 90"
                fill="none"
                stroke="url(#route)"
                strokeWidth="2"
                strokeDasharray="4 6"
              />

              {/* Points */}
              {[
                { x: 80, y: 360, label: "Biella" },
                { x: 260, y: 310, label: "Sagliano Micca · sede" },
                { x: 520, y: 200, label: "Campiglia Cervo" },
                { x: 720, y: 90, label: "Balma · cava" },
              ].map((p, i) => (
                <g key={i}>
                  <circle cx={p.x} cy={p.y} r="6" fill="#a69c8a" />
                  <circle cx={p.x} cy={p.y} r="14" fill="none" stroke="#a69c8a" strokeOpacity="0.3" />
                  <text
                    x={p.x + 18}
                    y={p.y + 4}
                    fill="#f2f2f2"
                    fontSize="13"
                    fontFamily="IBM Plex Sans"
                    letterSpacing="0.05em"
                  >
                    {p.label}
                  </text>
                </g>
              ))}
            </svg>
            <div className="absolute top-4 left-4 flex items-center gap-2 text-[0.65rem] tracking-[0.3em] uppercase text-neutral-400">
              <MapPin size={12} className="text-[var(--accent)]" />
              Mappa stilizzata · Valle Cervo
            </div>
          </div>

          <div className="grid md:grid-cols-4 gap-px bg-[var(--border-subtle)] mt-px">
            {stops.map((s, i) => (
              <div key={i} className="bg-[var(--surface-1)] p-5">
                <p className="text-[0.65rem] tracking-[0.25em] uppercase text-neutral-500">
                  Tappa 0{i + 1}
                </p>
                <p className="font-display text-lg md:text-xl text-neutral-100 mt-2">
                  {s.city}
                </p>
                <p className="text-xs text-neutral-500 mt-1">{s.coord}</p>
                <p className="text-xs text-neutral-400 mt-3">{s.note}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
